export default __webpack_public_path__ + "static/media/location-dark.1848fe40.svg";